import {swiper, swiperSlide} from 'vue-awesome-swiper';
import {BulmaAccordion, BulmaAccordionItem} from 'vue-bulma-accordion';
import HallsService from '@/common/halls.service';
import '@/assets/swiper/swiper.css';
import ApiService from '@/common/api.service';
import {CONTACT_TYPE_BOOTHPERSONAL} from '@/common/constants';
import LanguageService from '../../common/language.service';
import TreeStructure from '../TreeStructure.vue';
import {getFullUrl} from '../../common/UrlUtility';

const MEDIA_TYPE_VIDEO = '1';
const MEDIA_TYPE_DOCUMENT = '0';

export default {
  name: 'ExhibitorModalContent',
  components: {
    swiper,
    swiperSlide,
    BulmaAccordion,
    BulmaAccordionItem,
    TreeStructure,
  },
  data() {
    return {
      boothsInFair: [],
      contactsInFair: [],
      pointOfContactsInFair: [],
      mediaInFair: [],
      isVideoModal: false,
      videoModalUrl: '',
      videoModalTitle: '',
      brandsInFair: [],
      currentVideoEmbedHtml: '',
    };
  },
  props: {
    entry: {
      type: Object,
      default: null,
    },
    terminalmode: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: null,
    },
    categoriesTitle: {
      type: String,
      default: 'Kategorien',
    },
    extraCategoryTitle: {
      type: String,
      default: '',
    },
    travelDestinationTitle: {
      type: String,
      default: 'Reiseziele',
    },
    hallplanPath: {
      type: String,
      default: '',
    },
    existingEntries: {
      type: Array,
      default: [],
    },
    isFavourite: {
      type: Function,
      required: true,
    },
  },
  async mounted() {
    this.sortNews();
    if (this.entry.av_teaser && this.entry.av_teaser.link) {
      await this.getBoothsAndContactsForFair();
      this.currentVideoEmbedHtml = await this.getYoutubeEmbedLink(this.entry.av_teaser.link);
    } else {
      await this.getBoothsAndContactsForFair();
    }
  },
  methods: {
    getFullUrl,
    selectedFilterCategory(item) {
      this.$emit('selectedFilterCategory', item);
    },
    async getYoutubeEmbedLink(videoUrl) {
      const embedResult = await ApiService.get(`https://www.youtube.com/oembed?url=${videoUrl}&format=json`);
      if (embedResult.data && embedResult.data.html) {
        return embedResult.data.html;
      }
      return '';
    },
    async getYoutubeMediaThumbNail(videoUrl) {
      const url = videoUrl.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      // eslint-disable-next-line no-useless-escape
      const videoId = (url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0];
      const thumbnail = `https://img.youtube.com/vi/${videoId}/sddefault.jpg`;
      return thumbnail || '';
    },
    generateHallplanLink(booth) {
      // Not quite sure whether this works yet, so the other part is still commented
      const splittedIdentifier = booth.importBoothIdentifier.split(':');
      if (splittedIdentifier.length === 2) {
        let hallId = splittedIdentifier[0];
        const boothId = splittedIdentifier[1];

        // atr booths get redirected and displayed in EO now
        if (hallId === 'ATR') {
          hallId = 'EO';
        }

        return `${this.hallplanPath}#/${hallId}/${boothId}`;
      }

      return this.hallplanPath;

      // const fullHallId = booth.hallId;
      // // FIXME: this is a workaround for the unexpected behaviour of a
      // // booth having an already "complete" (url ready) boothId
      // const matchesCompleteBoothId = booth.boothId.match(/(\d+)([A-Z])(\d+)(\.(\d+))?/g);
      // if (matchesCompleteBoothId && matchesCompleteBoothId.length > 0
      //   && matchesCompleteBoothId[0] === booth.boothId) {
      //   return `${this.hallplanPath}#/${fullHallId}/${booth.boothId}`;
      // }
      // const hallId = fullHallId.replace(/\D/g, '');
      // const aisleLetter = booth.aisleLetter ? booth.aisleLetter : '';
      // return `${this.hallplanPath}#/${fullHallId}/${hallId}${aisleLetter}${booth.boothId}`;
    },
    setFavourite(entryId) {
      this.$emit('set-favourite', entryId);
    },
    showNewsDetail(news) {
      this.$emit('showNewsDetail', [news, this.entry]);
    },
    returnSocialMediaName(smType) {
      const type = parseInt(smType, 10);
      switch (type) {
        case 0:
          return 'Facebook';
        case 1:
          return 'Twitter';
        case 2:
          return 'LinkedIn';
        case 3:
          return 'YouTube';
        case 4:
          return 'Xing';
        case 5:
          return 'Instagram';
        case 6:
          return 'WhatsApp';
        case 7:
          return 'Snapchat';
        case 8:
          return 'Facebook Messenger';
        default:
          return '';
      }
    },
    sortNews() {
      this.entry.av_news.sort((a, b) => new Date(b.date) - new Date(a.date));
    },
    async getBoothsAndContactsForFair() {
      // const fairs = [];
      // this.entry['_childDocuments_'].forEach((fair) => { // eslint-disable-line
      //   fairs.push(fair.fair_id);
      // });
      // this.entry.av_booths.forEach((booth) => {
      //   if (fairs.indexOf(booth.fairId) !== -1) {
      //     this.boothsInFair.push(booth);
      //   }
      // });
      if (this.entry.contacts) {
        this.entry.contacts.forEach((contact) => {
          // if (fairs.indexOf(contact.fairId.split('-')[0]) !== -1) {
          const contactType = parseInt(contact.contactType, 10);
          if (contactType === CONTACT_TYPE_BOOTHPERSONAL) {
            this.pointOfContactsInFair.push(contact);
          } else {
            this.contactsInFair.push(contact);
          }
          // }
        });
      }
      const media = JSON.parse(this.entry.av_media);

      const mediaWithThumbs = media.map(async (me) => {
        if (me.type === '1') {
          // eslint-disable-next-line
          me.thumbnail = await this.getYoutubeMediaThumbNail(me.media);
        }
        return me;
      });

      this.mediaInFair = await Promise.all(mediaWithThumbs);
      if (this.entry.av_exhibitor_brands) {
        this.brandsInFair = JSON.parse(this.entry.av_exhibitor_brands);
      }
    },
    getHallNumber(hallId) {
      return HallsService.getHallNumber(hallId);
    },
    /* later necessary for chat channel */
    loadScript(url, callback) {
      const script = document.createElement('script');
      script.type = 'text/javascript';

      if (script.readyState) {
        // IE
        script.onreadystatechange = () => {
          if (script.readyState === 'loaded' ||
            script.readyState === 'complete') {
            script.onreadystatechange = null;
            callback();
          }
        };
      } else {
        // Others
        script.onload = () => {
          callback();
        };
      }
      script.src = url;
      document.getElementsByTagName('head')[0].appendChild(script);
    },
  },
  computed: {
    currentLanguage() {
      return LanguageService.getCurrentTYPO3Language();
    },
    languageFilteredSocialMedia() {
      if (this.entry.exhibitor_social_media && this.entry.exhibitor_social_media.length) {
        return this.entry.exhibitor_social_media.filter(m => m.lang === this.currentLanguage);
      }
      return [];
    },
    exhibitorProductsForShownFairs() {
      const products = [];
      this.entry.fair_ids.forEach((fair) => { // eslint-disable-line
        if (this.entry.av_products && this.entry.av_products[fair]) {
          const entries = this.entry.av_products[fair][0];
          products.push(...entries);
        }
      });
      return products;
    },
    getYoutubeVideoFrame() {
      return this.currentVideoEmbedHtml;
    },
    getVideos() {
      return this.mediaInFair.filter(item => item.type === MEDIA_TYPE_VIDEO);
    },
    getPdfs() {
      return this.mediaInFair.filter(item => item.type === MEDIA_TYPE_DOCUMENT);
    }
  },
};
